import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { makeQueryString } from "core/makeQueryString";
import { AxiosContext } from "contexts/AxiosContext";
import { PaginatedResponse } from "interfaces/utils";
import { ReportSections } from "interfaces/case-print";
import { REPORT_SECTIONS } from "constants/api_urls";

const STALE_TIME = 1000 * 60 * 15;

export const useReportSectionsQuery = (
  page = 1,
  pageSize = 10000
): UseQueryResult<PaginatedResponse<ReportSections[]>, unknown> => {
  const { axios } = useContext(AxiosContext)!;
  const queryString = makeQueryString({ page, size: pageSize });

  return useQuery({
    queryKey: ["report_sections", queryString],
    queryFn: async () => {
      const { data } = await axios.get<PaginatedResponse<ReportSections[]>>(
        `/${REPORT_SECTIONS}${queryString}`
      );

      return data;
    },
    staleTime: STALE_TIME
  });
};
